import comp from "./TaskWeightV3";
export default comp;
